<template>
    <div>
      <form-build
        form-name="form-name"
        :form-data.sync = "form"
        :form-rules="formRules"
        :form-columns-group="formColumnsGroup"
        :form-buttons="formButtons"
      >
      </form-build>
    </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import FormBuild from "../../components/FormBuild"

  export default {
    name: "PayFinancingComponent",
    data(){
      return {
        form: {
          "pay.transactionId": this.payTransactionId,
          "pay.cashier": "",
          "pay.payDate": "",
          "pay.remarks": "",
          "pay.payAccountId": "",
          "pay.loanAccountId": ""
        },
        formRules: {
          pay__payDate: [
            {
              required: true,
              message: '此项必填！'
            }
          ],
          pay__payAccountId: [
            {
              required: true,
              message: '此项必填！'
            }
          ],
          pay__loanAccountId: [
            {
              required: true,
              message: '此项必填！'
            }
          ]
        },
        formButtons: [
          {
            label: '确定',
            type: 'primary',
            clickHandler: ($refs)=>{
              $refs.validate(valid=>{
                if(valid) {
                  this.payFinancing()
                }
              })
            }
          },
          {
            label: '取消',
            type: '',
            clickHandler: $refs=>{
              this.$emit('done')
            }
          }
        ]
      }
    },
    props: {
      payTransactionId: {
        type: String
      },
      customerId: {
        type: String
      },
      payAccountList: {
        type: Array,
        default: ()=>{
          return []
        }
      },
      loanAccountList: {
        type: Array,
        default: ()=>{
          return []
        }
      },
      payFinancingVisible: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      payAccountOptions: function () {
        return this.payAccountList.map(item=>{
          return {
            key: item['ba__accountId'],
            label: item['ba__bank']+item['ba__branch']+item['ba__accountNo'],
            value: item['ba__accountId']
          }
        })
      },
      loanAccountOptions: function () {
        return this.loanAccountList.map(item=>{
          return {
            key: item['ba__accountId'],
            label: item['ba__bank']+item['ba__branch']+item['ba__accountNo'],
            value: item['ba__accountId']
          }
        })
      },
      formColumnsGroup: function() {
        return [
          {
            label: '',
            columns: [
              {
                label: '放款日期',
                component: 'el-date-picker',
                type: 'datetime',
                field: 'pay__payDate',
                valueFormat: "yyyy-MM-dd HH:mm:ss",
                span: 24
              },
              {
                label: '付款账户',
                component: 'el-select',
                field: 'pay__payAccountId',
                options: this.payAccountOptions,
                span: 24
              },
              {
                label: '收款账户',
                component: 'el-select',
                field: 'pay__loanAccountId',
                options: this.loanAccountOptions,
                span: 24
              }
            ]
          }
        ]
      }
    },
    components: {
      FormBuild
    },
    watch: {
      payAccountList: function(val){
        console.log(val)
      }
    },
    methods: {
      payFinancing: function () {
        xhr.payFinancing(
          this.form,
          res=>{
            try {
              if(res.data.status == 'success') {
                this.$emit('done')
              }
            }catch (e) {

            }
          }
        )
      }

    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/PayFinancingComponent.vue